import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {IconLeftArrow} from './IconButtons';

/**
 * @Description Arrow left icon component
 * @param String link: navigation url (optional).
 * @param event onBack: event click (required).
 * @param ReactComponent Icon  IconBack: The IconBack variable makes the back icon dynamic (optional).
 */
const ReturnArrow = ({ link, onBack , IconBack = null}) => {
    const navigate = useNavigate();
    return (
        <Link
            id={`lk_ra_link`}
            className='top-left-arrow-container'
            to={!link ? '#' : link}
            onClick={(e) => {
                if (typeof onBack === 'function' || !link) {
                    e.preventDefault();
                    if(typeof onBack === 'function') onBack();
                    else navigate(-1);
                }
            }}
        >
            <div className='btn-left-arrow'>
                {IconBack == null ?  <IconLeftArrow/> : <IconBack/>}
            </div>
        </Link>
    );
};

export default ReturnArrow;
